import React, {useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import {useHistory, useLocation, useParams} from 'react-router-dom';

import {bindActionCreators} from 'redux';
import {loadRestaurant} from '../../redux/actions/baseActions';
import {hideLoading, showLoading} from '../../redux/actions/loadingActions';
import { setLanguageId, setUiLanguageId } from '../../redux/actions/baseActions';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import './PaymentSuccessPage.scss';
import PayButton from '../../components/PayButton';
import {getLanguageById} from '../../helpers/language';

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

function sendSuccessMessage() {
    const message = { type: 'SUCCESSFUL_PAYMENT', success: true };
    window.parent.postMessage(message, '*');
}

const PaymentSuccessPage = (props) => {
    const { showLoading, hideLoading, t, setLanguageId, setUiLanguageId, loadRestaurant, branchInfo, currentLanguageId } = props;
    const query = useQuery();
    const {branchId} = useParams();
    const history = useHistory();
    const localeParam = query.get('locale');

    useEffect(() => {
        const load = async () => {
            if (branchId) {
                await loadRestaurant(branchId, true);
            }
        };
        load();
    }, [branchId]);

    useEffect(() => {
        setTimeout(() => {
            hideLoading();
            sendSuccessMessage();
        }, 500);

    }, []);

    useEffect(() => {
        setLanguageId(localeParam === 'en' ? 1 : 2);
        setUiLanguageId(localeParam === 'en' ? 1 : 2);
    }, [localeParam]);

    const onOkClick = () => {
        const lang = getLanguageById(currentLanguageId);
        if (branchInfo && branchInfo.branch_guid_code){
            history.push(`/${branchInfo.branch_guid_code}/type?lang=${lang}`);
        } else {
            history.push('/');
        }
    };

    return (
        <div className="payment-success-page">
            <div className="success-message">
                {t('order.submit.success_title')}
            </div>

            <div className="info-icon">
                <FontAwesomeIcon icon="check-circle" />
            </div>

            <div className="btn ok-button" onClick={ onOkClick }>
                {t('payment_success_page.accept_btn')}
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    const {
        currentLanguageId,
        branchInfo
    } = state;

    return {
        currentLanguageId,
        branchInfo
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            showLoading,
            hideLoading,
            setLanguageId,
            setUiLanguageId,
            loadRestaurant
        },
        dispatch,
    );

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(PaymentSuccessPage));
